export function formatBotResponseHTML(raw: string): string {
  const allowedTags = ["ImageResponseCard", "button", "img", "a"];
  const imageStyles = "margin-top:10px;margin-bottom:10px;width:100%";

  const escapeHTML = (str: string) =>
    str.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");

  // 1) Encode allowed tags so they don't get escaped
  let marked = raw.replace(
    new RegExp(`<\\/?(${allowedTags.join("|")})[^>]*>`, "g"),
    (match) => `__HTMLTAG__${btoa(match)}__ENDTAG__`
  );

  // 2) Convert Markdown images BEFORE escaping
  marked = marked.replace(
    /!\[([^\]]*)\]\(\s*<?([^)\s]+)>?(?:\s+["'][^"']*["'])?\s*\)/g,
    (_, alt, url) => {
      if (!/^https?:/i.test(url)) return _;
      return `<img src="${url}" alt="${alt}" style="${imageStyles}"/>`;
    }
  );

  // 3) Escape everything else
  let safe = escapeHTML(marked);

  // 4) Normalize line endings
  safe = safe.replace(/\r\n|\r/g, "\n");

  // 5) Inline formatting (bold etc.)
  safe = safe.replace(/\*\*(.+?)\*\*/g, "<strong>$1</strong>");

  // 6) Block parsing
  const lines = safe.split("\n");
  let inUl = false;
  let inOl = false;
  const parsedLines: string[] = [];

  for (let line of lines) {
    line = line.trim();

    // Headings
    const headingMatch = line.match(/^(#{1,6})\s+(.*)$/);
    if (headingMatch) {
      if (inUl) {
        parsedLines.push("</ul>");
        inUl = false;
      }
      if (inOl) {
        parsedLines.push("</ol>");
        inOl = false;
      }
      parsedLines.push(
        `<h${headingMatch[1].length}>${headingMatch[2]}</h${headingMatch[1].length}>`
      );
      continue;
    }

    // Unordered lists (- or •)
    if (line.startsWith("- ") || line.startsWith("• ")) {
      if (!inUl) {
        parsedLines.push("<ul>");
        inUl = true;
      }
      parsedLines.push(`<li>${line.substring(2).trim()}</li>`);
      continue;
    }

    // Ordered lists (1. Item)
    const olMatch = line.match(/^(\d+)\.\s+(.*)$/);
    if (olMatch) {
      if (!inOl) {
        parsedLines.push("<ol>");
        inOl = true;
      }
      parsedLines.push(`<li>${olMatch[2]}</li>`);
      continue;
    }

    // Blockquotes (> )
    if (line.startsWith("> ")) {
      if (inUl) {
        parsedLines.push("</ul>");
        inUl = false;
      }
      if (inOl) {
        parsedLines.push("</ol>");
        inOl = false;
      }
      parsedLines.push(`<blockquote>${line.substring(2).trim()}</blockquote>`);
      continue;
    }

    // Close lists when normal text starts
    if (inUl) {
      parsedLines.push("</ul>");
      inUl = false;
    }
    if (inOl) {
      parsedLines.push("</ol>");
      inOl = false;
    }

    // Normal text
    if (line) parsedLines.push(`<p>${line}</p>`);
  }

  if (inUl) parsedLines.push("</ul>");
  if (inOl) parsedLines.push("</ol>");
  safe = parsedLines.join("\n");

  // 7) Linkify URLs
  const urlRegex = /(https?:\/\/[^\s<]+)/g;
  safe = safe
    .split(/(<[^>]+>)/g)
    .map((chunk) =>
      chunk.startsWith("<")
        ? chunk
        : chunk.replace(
            urlRegex,
            '<a href="$1" target="_blank" rel="noopener noreferrer">$1</a>'
          )
    )
    .join("");

  // 8) Decode allowed tags
  safe = safe.replace(/__HTMLTAG__(.*?)__ENDTAG__/g, (_, encoded) => {
    const decoded = atob(encoded).trim();

    if (decoded === "<ImageResponseCard>")
      return `<div class="iris-button-class-container--blk">`;
    if (decoded === "</ImageResponseCard>") return `</div>`;

    if (decoded.startsWith("<button") || decoded.includes("<button")) {
      return decoded.replace(
        /<button(.*?)>/g,
        `<button class="iris-button-class"$1>`
      );
    }
    if (decoded === "</button>") return `</button>`;

    if (decoded.startsWith("<img") || decoded.includes("<img")) {
      return decoded;
    }

    return decoded;
  });

  return safe;
}
